import { getConfigValue } from '../../Providers/ConfigsApi';

export default async function categoryPagePreviewEnabled() {
  const configKey = 'issuu-category';

  try {
    const issuuCategoryPreview = await getConfigValue(configKey);
    return issuuCategoryPreview.length > 0 && issuuCategoryPreview[0].toLowerCase() === 'on';
  } catch (err) {
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/Common/Helpers/CategoryPagePreview/CategoryPagePreviewEnabled.js